import axios from 'axios'
import Vue from 'vue'
import { ResponseWrapper, ErrorWrapper } from './util'
import $store from '../store'
import $router from '../router'
import { API_URL } from '../.env'

let BEARER = ''

export class AuthService {
  /**
   ******************************
   * @API
   ******************************
   */

  static async makeLogin ({ username, password }) {
    try {
      const response = await axios.post(`${API_URL}/login`,
        { username, password },
        { withCredentials: true })
      _setAuthData({
        accessToken: response.data
      })
      const userData = Vue.$jwt.decode(response.data)
      if (!userData.is_owner && !!userData.not_allow_permissions && userData.not_allow_permissions.includes('access_to_xreport')) {
        throw new ErrorWrapper(new Error('You are not allowed to access this page at this time.'))
      }
      localStorage.setItem('currentUser', JSON.stringify(userData))
      localStorage.setItem('token', response.data)
      return new ResponseWrapper(response, userData)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async makeLogout () {
    _resetAuthData()
    $router.push({ name: 'login' }).catch(() => {})
  }

  /**
   ******************************
   * @METHODS
   ******************************
   */

  static getBearer () {
    return BEARER
  }

  static setBearer (accessToken) {
    BEARER = `Bearer ${accessToken}`
  }

  /**
   * https://stackoverflow.com/questions/35228052/debounce-function-implemented-with-promises
   * @param inner
   * @param ms
   * @returns {function(...[*]): Promise<unknown>}
   * @private
   */
  static _debounce (inner, ms = 0) {
    let timer = null
    let resolves = []

    return function () {
      clearTimeout(timer)
      timer = setTimeout(() => {
        const result = inner()
        resolves.forEach(r => r(result))
        resolves = []
      }, ms)

      return new Promise(resolve => resolves.push(resolve))
    }
  }
}

/**
 ******************************
 * @private_methods
 ******************************
 */

function _resetAuthData () {
  // reset userData in store
  $store.commit('user/SET_CURRENT_USER', {})
  localStorage.clear()
  // reset tokens
  AuthService.setBearer('')
}

function _setAuthData ({ accessToken } = {}) {
  AuthService.setBearer(accessToken)
}
